import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-custom-ion-input',
  standalone: true,
  templateUrl: './custom-ion-input.component.html',
  styleUrls: ['./custom-ion-input.component.scss'],
  imports: [CommonModule, IonicModule, ReactiveFormsModule],
})
export class CustomIonInputComponent extends FieldType<FieldTypeConfig> {

  constructor(protected translocoService: TranslocoService) {
    super();
  }

  override get showError(): boolean {
    return (
      !!this.formControl &&
      this.formControl.invalid &&
      (this.formControl.touched ||
        (this.options.parentForm as any)?.submitted)
    );
  }

  get errorMessage(): string | null {
    if (!this.formControl?.errors) return null;

    const errors: ValidationErrors = this.formControl.errors;
    const errorKey: string = Object.keys(errors)[0];
    const message = this.props['validation']?.messages?.[errorKey];

    return message ? this.translocoService.translate('FORMLY.ERROR.' + message) : this.translocoService.translate('FORMLY.ERROR.FIELD_REQUIRED')
  }
}
